__turbopack_context__.v({
  "body": "MDNupa_body",
  "button": "MDNupa_button",
  "empty": "MDNupa_empty",
  "errorField": "MDNupa_errorField",
  "errorItem": "MDNupa_errorItem",
  "errorList": "MDNupa_errorList",
  "errorMsg": "MDNupa_errorMsg",
  "flag": "MDNupa_flag",
  "flagDot": "MDNupa_flagDot",
  "flagDotOff": "MDNupa_flagDotOff",
  "flagDotOn": "MDNupa_flagDotOn",
  "flagGrid": "MDNupa_flagGrid",
  "key": "MDNupa_key",
  "numCell": "MDNupa_numCell",
  "panel": "MDNupa_panel",
  "pill": "MDNupa_pill",
  "pillError": "MDNupa_pillError",
  "pillMuted": "MDNupa_pillMuted",
  "pillOk": "MDNupa_pillOk",
  "pillWarn": "MDNupa_pillWarn",
  "rawPre": "MDNupa_rawPre",
  "row": "MDNupa_row",
  "section": "MDNupa_section",
  "sectionBody": "MDNupa_sectionBody",
  "sectionCount": "MDNupa_sectionCount",
  "sectionIcon": "MDNupa_sectionIcon",
  "sectionSummary": "MDNupa_sectionSummary",
  "sectionTitle": "MDNupa_sectionTitle",
  "srOnly": "MDNupa_srOnly",
  "summary": "MDNupa_summary",
  "summaryBadge": "MDNupa_summaryBadge",
  "summaryBadgeError": "MDNupa_summaryBadgeError",
  "summaryBadgeOk": "MDNupa_summaryBadgeOk",
  "summaryIcon": "MDNupa_summaryIcon",
  "summaryTitle": "MDNupa_summaryTitle",
  "table": "MDNupa_table",
  "val": "MDNupa_val",
  "valError": "MDNupa_valError",
  "valNull": "MDNupa_valNull",
  "valNumber": "MDNupa_valNumber",
  "valOk": "MDNupa_valOk",
  "valString": "MDNupa_valString",
  "valWarn": "MDNupa_valWarn",
});
